import { formatCoin as formatCoinDefault } from "@marginly/ui/util/format-coin";
import BigNumber from "bignumber.js";

export const formatCoin = (
  value: number | BigNumber | string | undefined | null,
): React.ReactNode => {
  const adaptedValue = value instanceof BigNumber ? value.toNumber() : value;
  return formatCoinDefault(adaptedValue);
};
